var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8477 3.82031C16.1641 4.13672 16.375 4.55859 16.375 5.01562V14.4375C16.375 15.3867 15.6016 16.125 14.6875 16.125H2.3125C1.36328 16.125 0.625 15.3867 0.625 14.4375V2.0625C0.625 1.14844 1.36328 0.375 2.3125 0.375H11.7344C12.1914 0.375 12.6133 0.585938 12.9297 0.902344L15.8477 3.82031ZM10.1875 2.0625H5.6875V4.875H10.1875V2.0625ZM14.4766 14.4375C14.582 14.4375 14.6875 14.3672 14.6875 14.2266V5.12109C14.6875 5.05078 14.6523 5.01562 14.6172 4.98047L11.875 2.20312V5.71875C11.875 6.21094 11.4883 6.5625 11.0312 6.5625H4.84375C4.35156 6.5625 4 6.21094 4 5.71875V2.0625H2.52344C2.38281 2.0625 2.3125 2.16797 2.3125 2.27344V14.2266C2.3125 14.3672 2.38281 14.4375 2.52344 14.4375H14.4766ZM8.5 7.40625C10.1875 7.40625 11.5938 8.8125 11.5938 10.5C11.5938 12.2227 10.1875 13.5938 8.5 13.5938C6.77734 13.5938 5.40625 12.2227 5.40625 10.5C5.40625 8.8125 6.77734 7.40625 8.5 7.40625ZM8.5 11.9062C9.27344 11.9062 9.90625 11.3086 9.90625 10.5C9.90625 9.72656 9.27344 9.09375 8.5 9.09375C7.69141 9.09375 7.09375 9.72656 7.09375 10.5C7.09375 11.3086 7.69141 11.9062 8.5 11.9062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save_icon.a34ca979407f08dfcdb86d7099cc6bc5.svg";
export { ForwardRef as ReactComponent };